import { useEffect, useState } from 'react'

const DISMISS_KEY = 'pwa-install-dismissed'
const INSTALLED_KEY = 'pwa-installed'
const DISMISS_DAYS = 7

function isMobile() {
  if (typeof window === 'undefined') return false
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 0)
}

function wasDismissedRecently() {
  try {
    const raw = localStorage.getItem(DISMISS_KEY)
    if (!raw) return false
    const t = parseInt(raw, 10)
    if (isNaN(t)) return false
    return Date.now() - t < DISMISS_DAYS * 24 * 60 * 60 * 1000
  } catch {
    return false
  }
}

function isStandalone() {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true ||
    document.referrer.includes('android-app://')
}

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [showBanner, setShowBanner] = useState(false)
  const [isIOS, setIsIOS] = useState(false)

  useEffect(() => {
    if (!isMobile()) return
    if (isStandalone()) {
      try {
        localStorage.setItem(INSTALLED_KEY, String(Date.now()))
      } catch {}
      return
    }
    if (wasDismissedRecently()) return

    const isApple = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    setIsIOS(isApple)

    if (isApple) {
      setShowBanner(true)
      return
    }

    const onBeforeInstall = (e) => {
      e.preventDefault()
      setDeferredPrompt(e)
      setShowBanner(true)
    }
    window.addEventListener('beforeinstallprompt', onBeforeInstall)
    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstall)
  }, [])

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt()
      const { outcome } = await deferredPrompt.userChoice
      if (outcome === 'accepted') {
        try {
          localStorage.setItem(INSTALLED_KEY, String(Date.now()))
        } catch {}
      }
      setDeferredPrompt(null)
      setShowBanner(false)
    } else {
      setShowBanner(false)
    }
  }

  const handleDismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now()))
    } catch {}
    setShowBanner(false)
  }

  if (!showBanner) return null

  return (
    <div
      className="pwa-install-banner"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: 'linear-gradient(135deg, #317EFB 0%, #1a5bb8 100%)',
        color: '#fff',
        padding: '12px 16px',
        boxShadow: '0 -2px 12px rgba(0,0,0,0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        {isIOS ? (
          <span style={{ fontSize: '14px' }}>
            Add to Home Screen: tap <strong>Share</strong> then <strong>Add to Home Screen</strong>
          </span>
        ) : (
          <span style={{ fontSize: '14px' }}>
            Install app for quick access and use offline
          </span>
        )}
      </div>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {!isIOS && deferredPrompt && (
          <button
            type="button"
            onClick={handleInstall}
            style={{
              padding: '8px 16px',
              background: '#fff',
              color: '#317EFB',
              border: 'none',
              borderRadius: '8px',
              fontWeight: 600,
              fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            Add to Home Screen
          </button>
        )}
        <button
          type="button"
          onClick={handleDismiss}
          style={{
            padding: '8px 12px',
            background: 'rgba(255,255,255,0.2)',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            cursor: 'pointer',
          }}
        >
          Not now
        </button>
      </div>
    </div>
  )
}
